






































































































































const namespace = 'form';
import { Vue, Component } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import EventBus from '@/communication/EventBus';
import OdataResource from '@/modules/api/OdataResource';
import FormFields from '@/modules/form/components/FormFields.vue';
import IFromFlow from '@/modules/form/interfaces/IFormFlow';
import IFormState from '@/modules/form/interfaces/IFormState';
import IFormField from '@/modules/form/interfaces/IFormField';
import IPeriodicalGroup from '@/modules/form/interfaces/IPeriodicalGroup';
import IRegistrationSurvey from '@/modules/form/interfaces/IRegistrationSurvey';
import ISubmitEventRegistrationFormRequest from '@/modules/form/interfaces/ISubmitEventRegistrationFormRequest';
import EventRegistration from './EventRegistration';
import { generateClientIP } from '@/utils/web';
import { convertToNumber } from '@/utils/payment';

@Component({
    name: 'GenericForm',
    components: {
        FormFields,
    },
})
export default class GenericForm extends Vue {
    @Getter('apiUrl', { namespace: 'configuration' }) private apiUrl!: string;
    @Getter('currentEventId', { namespace: 'form' }) private currentEventId!: number;
    @Getter('currentFormFlowId', { namespace: 'form' }) private currentFormFlowId!: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('changeGenericFormState', { namespace }) private changeGenericFormState: any;
    private currentStep = 1;
    private steps = 1;
    private vertical = false;

    private registrationGuid = '';
    private registrationId = 0;
    private readonly FormStates = this.apiUrl + '/odata/forms/FormStates';
    private FormFlows = this.apiUrl + `/odata/registrations/EventRegistrations(${this.registrationId})/FormFlows`;
    private readonly PeriodicalGroups = this.apiUrl + '/odata/schedules/PeriodicalGroups';
    private readonly SubmitEventRegistrationFormRequests =
        this.apiUrl + '/odata/registrations/SubmitEventRegistrationFormRequests';
    private eventId = 5;
    private eventTypeId = 5;
    private formFlowId = 1;
    private formStateId = 1;
    private formStateName = 'New';
    private formFlows: IFromFlow[] = [];
    private formStates: IFormState[] = [];
    private errorMessage = '';
    private errored = false;
    private loading = false;
    private formStatesResource: OdataResource<IFormState> = new OdataResource<IFormState>(
        this.FormStates,
        this.onResourceLoading,
        this.onResourceLoadingFinished,
        this.onError,
        this.onFormStatesLoaded,
    );
    private formFlowsResource: OdataResource<IFromFlow> = new OdataResource<IFromFlow>(
        this.FormFlows,
        this.onResourceLoading,
        this.onResourceLoadingFinished,
        this.onError,
        this.onFormFlowsLoaded,
    );
    private eventRegistartionsResource: OdataResource<ISubmitEventRegistrationFormRequest> = new OdataResource<
        ISubmitEventRegistrationFormRequest
    >(this.SubmitEventRegistrationFormRequests, this.onResourceLoading, this.onResourceLoadingFinished, this.onError);
    private periodicalGroupsResource: OdataResource<IPeriodicalGroup> = new OdataResource<IPeriodicalGroup>(
        this.PeriodicalGroups,
        this.onResourceLoading,
        this.onResourceLoadingFinished,
        this.onError,
    );

    private get currentFormStates(): IFormState[] {
        return this.formStates !== undefined ? this.formStates.filter(x => this.isCurrentFormState(x)) : [];
    }

    private get currentFormState(): IFormState | undefined {
        return this.formStates.find(f => f.Id === this.formStateId);
    }

    private get visibleFormStates(): IFormState[] {
        return this.formStates !== undefined ? this.formStates.filter(x => x.IsVisible) : [];
    }

    private get isSessionContinuation() {
        return this.$route.query.g !== undefined && this.$route.query.i !== undefined;
    }

    private get isReturnFromPayment() {
        return this.$route.query.session_id !== undefined;
    }

    private get formFlowsUri() {
        let resourceUri = `/odata/forms/FormFlows`;
        if (this.registrationId > 0) {
            resourceUri = `/odata/registrations/EventRegistrations(${this.registrationId})/FormFlows`;
        }

        return this.apiUrl + resourceUri;
    }

    private getVisibleFormStatesStepLabel(stepIdx: number) {
        return this.visibleFormStates[stepIdx - 1]?.Label ?? '1';
    }

    private async mounted() {
        this.formStatesResource.baseUrl = this.apiUrl + '/odata/forms/FormStates';
        this.formFlowsResource.baseUrl =
            this.apiUrl + `/odata/registrations/EventRegistrations(${this.registrationId})/FormFlows`;
        this.eventRegistartionsResource.$on('resourceCreated', this.onEventRegistartionCreated);
        this.eventRegistartionsResource.baseUrl =
            this.apiUrl + '/odata/registrations/SubmitEventRegistrationFormRequests';
        this.periodicalGroupsResource.baseUrl = this.apiUrl + '/odata/schedules/PeriodicalGroups';

        const eventId =
            this.$route.query.e ||
            this.$route.query.eventId ||
            this.$route.query.EventId ||
            this.currentEventId.toString();
        if (eventId !== undefined) {
            this.eventId = +eventId as number;

            const eventTypeId = await this.getEventTypeId(this.eventId);
            if (eventTypeId !== undefined) {
                this.eventTypeId = +eventTypeId as number;
            }
        }

        EventBus.$on('paymentCompleated', async (event: any) => {
            this.loadFormStateForRegistration(event.eventId, event.eventGuid, true);
        });

        generateClientIP();
        await this.init();

        if (this.isSessionContinuation) {
            const eventRegistrationId = +this.$route.query.i as number;
            const eventRegistrationGuid = this.$route.query.g as string;
            const loadExactRegistration = (this.$route.query.c as string) == 'true';
            this.loadFormStateForRegistration(eventRegistrationId, eventRegistrationGuid, loadExactRegistration);
            // this.cleanUrlParameters();

            return;
        }

        if (this.isReturnFromPayment) {
            if (this.$route.query.error) {
                this.errorMessage =
                    'Payment error code: ' + this.$route.query.error + '<br/> Please contact with the administrator.';
                console.error(this.errorMessage);
            }
            const sessionId = this.$route.query.session_id as string;
            const posId = this.$route.query.pos_id as string;
            const amount = this.$route.query.amountPS as string;
            const payType = this.$route.query.payType as string;

            const userPaymentSessionData = this.loadUserPaymentSessionData(sessionId);
            if (userPaymentSessionData === null) {
                return;
            }

            const paymentConfirmationData = {
                SessionId: sessionId,
                PosId: posId,
                Amount: amount,
                Paid: convertToNumber(amount),
                PayType: payType,
                EventRegistrationId: userPaymentSessionData.EventRegistrationId,
                EventRegistrationGuid: userPaymentSessionData.EventRegistrationGuid,
            };

            this.eventId = userPaymentSessionData.EventId;
            this.eventTypeId = userPaymentSessionData.EventTypeId;

            this.confirmPayment(paymentConfirmationData);
            this.cleanUrlParameters();
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private onFormSubmit(event: any): void {
        const formFields: IFormField[] = event.formFields;
        this.formSubmit(formFields, event.trigger);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private onMealsSelected(event: any): void {
        this.loadFormStateForRegistration(event.EventRegistrationId, event.EventRegistrationGuid);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private onError(data: any) {
        console.error(data);
        this.errored = true;
        if (data.error !== undefined) {
            this.errorMessage = data.error.message;
        }
    }

    private onFormStatesLoaded(formStates: IFormState[]) {
        this.formStates = formStates;
        // this.refresh();
        this.setGenericFormState();
    }

    private setGenericFormState() {
        this.changeGenericFormState({
            currentStepIdx: +(this.currentFormState?.StepNumber ?? '1'),
            formStateId: this.formStateId,
            formStateName: this.formStateName,
            currentFormState: this.currentFormState ?? this.formStates[this.currentStep - 1],
            formFields: [],
        });
    }

    private onFormFlowsLoaded(formFlows: IFromFlow[]) {
        this.formFlows = formFlows.length > 0 ? [formFlows[0]] : [];
    }

    private async onEventRegistartionCreated(submitEventRegistrationFormRequest: ISubmitEventRegistrationFormRequest) {
        const eventRegistration = submitEventRegistrationFormRequest.EventRegistration;
        const newFormState = this.formStates.find(x => x.Name === eventRegistration.Status);
        this.registrationGuid = eventRegistration.Guid;
        this.registrationId = eventRegistration.Id;
        if (newFormState !== undefined) {
            // this.formStateId = newFormState.Id;
            // this.formStateName = newFormState.Name;
            this.formStateId = eventRegistration.StateId;
            this.formStateName = eventRegistration.Status;
            await this.init();
        }
    }

    private onResourceLoading() {
        this.loading = true;
    }

    private onResourceLoadingFinished() {
        this.loading = false;
    }

    private isCurrentFormState(formState: IFormState): boolean {
        return formState.Id === this.formStateId;
    }

    private isNotLastStep(formStateIdx: number): boolean {
        return formStateIdx < this.visibleFormStates.length;
    }

    private async init() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;

        self.errored = false;
        const formFlows = await self.getFormFlow(this.eventTypeId);
        if (formFlows !== undefined && formFlows.length > 0) {
            let formFlowId = formFlows[0].Id;

            if (this.currentFormFlowId !== undefined && this.currentFormFlowId > 0) {
                formFlowId = this.currentFormFlowId;
            }

            const formStates = await self.getFormStates(formFlowId);
            if (formStates !== undefined && formStates.length > 0 && this.formStateId === 1) {
                const currentFormState = formStates[0];
                this.formStateId = currentFormState.Id;
            }

            this.steps = formStates?.length ?? 1;
            this.currentStep = +(this.currentFormState?.StepNumber ?? '1');

            this.setGenericFormState();
        }
        console.log('no FormFlows loaded.');
    }

    private async getFormFlow(eventTypeId: number) {
        this.formFlowsResource.baseUrl = this.formFlowsUri;
        let query = '$filter=EventTypeId eq ' + eventTypeId;
        if (this.registrationId > 0) {
            query = '';
        }

        // const formFlows = await this.formFlowsResource.getResources('$filter=EventTypeId eq ' + eventTypeId);
        const formFlows = await this.formFlowsResource.getResources(query);
        return formFlows ? [formFlows[0]] : [];
    }

    private async getFormStates(formFlowId: number) {
        return await this.formStatesResource.getResources('$filter=IsActive eq true and FormFlowId eq ' + formFlowId);
    }

    private async getEventTypeId(eventId: number) {
        const periodicalGroup = await this.periodicalGroupsResource.getResource(eventId);
        let eventTypeId = 0;
        if (periodicalGroup !== undefined) {
            eventTypeId = periodicalGroup.GroupTypeId;
        }

        return eventTypeId;
    }

    private reloadPage() {
        this.init();
    }

    private cleanUrlParameters() {
        window.history.replaceState(null, '', '/');
    }

    private loadFormStateForRegistration(
        registrationId: number,
        registrationGuid: string,
        loadExactRegistration = false,
    ): void {
        this.registrationId = registrationId;
        this.registrationGuid = registrationGuid;
        const submitEventRegistrationFormRequest: ISubmitEventRegistrationFormRequest = {
            Trigger: loadExactRegistration ? 'GetThisRegistrationState' : 'GetState',
            EventRegistration: { Id: this.registrationId, Guid: this.registrationGuid },
        } as ISubmitEventRegistrationFormRequest;

        this.eventRegistartionsResource.createNewResource(
            submitEventRegistrationFormRequest,
            '$expand=EventRegistration',
        );
        // this.cleanUrlParameters();
    }

    private formSubmit(formFields: IFormField[], trigger: string): void {
        const eventRegistration: EventRegistration = this.createEventRegistration(formFields);
        const registrationSurvey: IRegistrationSurvey = this.createRegistrationSurvey(formFields);
        const submitEventRegistrationFormRequest: ISubmitEventRegistrationFormRequest = {
            Trigger: trigger,
            EventRegistration: eventRegistration,
            RegistrationSurvey: registrationSurvey,
        } as ISubmitEventRegistrationFormRequest;

        this.eventRegistartionsResource.createNewResource(
            submitEventRegistrationFormRequest,
            '$expand=EventRegistration',
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private confirmPayment(paymentConfirmationData: any) {
        const formFields: IFormField[] = [{ Name: 'Paid', Value: paymentConfirmationData.Paid }] as IFormField[];
        this.registrationId = paymentConfirmationData.EventRegistrationId;
        this.registrationGuid = paymentConfirmationData.EventRegistrationGuid;
        this.formSubmit(formFields, 'Submit');
    }

    private createEventRegistration(formFields: IFormField[]): EventRegistration {
        let eventRegistration: EventRegistration = new EventRegistration();

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const data: any = {};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        for (const [key, value] of Object.entries(eventRegistration)) {
            const property = formFields.find(x => x.Name === key);
            if (property !== undefined) {
                data[property.Name] = property.Value;
            }
        }
        eventRegistration = data as EventRegistration;
        eventRegistration.EventId = this.eventId;
        eventRegistration.Status = this.formStateName;
        if (this.registrationGuid) {
            eventRegistration.Guid = this.registrationGuid;
        }

        const recomendee = this.$route.query.rec as string;
        if (recomendee !== undefined) {
            eventRegistration.RecommendedBy = recomendee;
        }

        const specialCode = this.$route.query.sc as string;
        if (specialCode !== undefined) {
            eventRegistration.SpecialCode = specialCode;
        }

        return eventRegistration;
    }

    private createRegistrationSurvey(formFields: IFormField[]): IRegistrationSurvey {
        // TODO: Get survey definition and use it to populate RegistrationSurvey and SurveyAnswers.
        const properties = Object.getOwnPropertyNames(new EventRegistration());
        const answersFields = formFields.filter(
            x => !properties.includes(x.Name) && x.FieldType !== 'SubmitButton' && x.FieldType !== 'Html',
        );
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const surveyAnswers: any[] = answersFields.map(a => ({
            Number: a.Id,
            Content: a.Value != null ? a.Value.toString() : null,
        }));
        const registrationSurvey: IRegistrationSurvey = {
            Id: 0,
            SurveyAnswers: surveyAnswers,
        };

        return registrationSurvey;
    }

    private loadUserPaymentSessionData(sessionId: string) {
        const paymentRequestId = 'paymentRequest' + sessionId;
        const userPaymentSessionDataJson = localStorage.getItem(paymentRequestId) as string;
        if (userPaymentSessionDataJson === undefined || userPaymentSessionDataJson === null) {
            // Error: session doesn't belong to this user
            this.errored = true;
            return null;
        }

        localStorage.removeItem(paymentRequestId);
        const userPaymentSessionData = JSON.parse(userPaymentSessionDataJson);
        return userPaymentSessionData;
    }
}
